import { observer } from 'mobx-react';
import { Stack } from '@servicetitan/design-system';
import { DisplayInfo } from '../helper-components/display-info';
import { FlowCardRadioOptions, FlowCardRadioForm } from './flow-card-radio';

interface FlowCardRadioCompletedProps {
    form: FlowCardRadioForm;
    options: FlowCardRadioOptions[];
    title: string;
}

export const FlowCardRadioCompleted = observer((props: FlowCardRadioCompletedProps) => {
    const selection = props.form.$.answer.value;
    const { label } = props.options.find(x => {
        return x.id === selection;
    })!;
    return (
        <Stack direction="column">
            <Stack direction="row" className="m-b-3 w-50">
                <DisplayInfo className="w-100-i" title={props.title.toUpperCase()} body={label} />
            </Stack>
        </Stack>
    );
});
